import RoleManager from "dev/helpers/RoleManager";
import store from "dev/store";

const AuthCheck = {};

function userCanUse($rules) {
	if (!Array.isArray($rules)) {
		$rules = [$rules];
	}
	const roleId = store.state.AuthModule.user.role;
	let role = RoleManager.getRoleById(roleId);
	return $rules.includes(role.rule);
}

function commentNode(el, vnode) {
	const comment = document.createComment(" ");

	Object.defineProperty(comment, "setAttribute", {
		value: () => undefined
	});

	vnode.text = " ";
	vnode.elm = comment;
	vnode.isComment = true;
	vnode.context = undefined;
	vnode.tag = undefined;
	vnode.data.directives = undefined;

	if (vnode.componentInstance) {
		vnode.componentInstance.$el = comment;
	}

	if (el.parentNode) {
		el.parentNode.replaceChild(comment, el);
	}
}

AuthCheck.install = function (Vue) {
	Vue.prototype.$auth = ($rules) => {
		return userCanUse($rules);
	};

	Vue.directive("can", function (el, bindings, vnode) {
		if (!userCanUse(bindings.value)) {
			commentNode(el, vnode);

		}
	});
	Vue.directive("cant", function (el, bindings, vnode) {
		if (userCanUse(bindings.value)) {
			commentNode(el, vnode);
		}
	});
};
export default AuthCheck;
